import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { themeColor } from "@TKCCP/Styles/variables";
import { css } from "styled-components";

// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// Load all the extensions to the base widgets. This includes style extensions.
// const widgetExtensions = require.context("./WidgetExtensions", true);
// widgetExtensions.keys().forEach(key => widgetExtensions(key));
// add some post styleguide customizations. These cannot be overridden by the style guid.
const store = require.context("./Store", true);
store.keys().forEach(key => store(key));

setPostStyleGuideTheme({
    colors: {
        text: {
            main: themeColor.colorGrey,
            link: themeColor.colorLightBlue,
        },
        secondary: {
            main: themeColor.colorSecondaryBlue,
        },
    },

    typography: {
        fontFamilyImportUrl: "/staticContent/stylesheet.css",
        h2: {
            css: css`
                color: ${themeColor.colorSecondary};
            `,
        },
        headerPrimary:{
            fontFamily: "'Calibri-Bold', 'Roboto', 'Lato', sans-serif",
        },
        headerSecondary:{
            fontFamily: "'Calibri-Bold', 'Roboto', 'Lato', sans-serif",
        },
        headerTertiary:{
            fontFamily: "'Calibri-Bold', 'Roboto', 'Lato', sans-serif",
        }
    },
    globalStyle: {
        css: css`
            *:focus {
                box-shadow: none !important;
                outline: none !important;
            }
            [data-test-selector="page_HomePage"]{
                header {
                    padding-bottom: 0 !important;
                }
                main{
                    padding-top: 0!important;
                    padding-bottom: 2px;
                    >div{
                        border-top: 1px solid #6c757d;
                    }
                    h2{
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    null,
                                    css`
                                       margin: 25px 0;
                                    `,
                                    null,
                                ],
                                "max",
                            );
                        }}
                    }
                }  
                [data-test-selector="productCarousel_topSellers"]{
                    [data-test-selector="addToListLink"]{
                        margin-bottom: 0;
                    }
                }
            }
            [data-test-selector="page_CategoryDetailsPage"]{
                main{
                    > div > div > div > div{
                        -webkit-flex-basis: 100%;
                        -ms-flex-preferred-size: 100%;
                        flex-basis: 100%;
                        max-width: 100%;
                    }
                }
            }
            header{
                > div:nth-child(3) {
                    height: 45px; 
                    line-height: normal;
                    button{
                        min-height: 45px;
                    }
                }
            }
            body #react-app{
                footer {
                    padding-top: 0;
                }
            }
            @media print {
                h1 {
                    font-size: 20px !important;
                }
                h2 {
                    font-size: 16px;
                }
                body {
                    font-size: 14px !important;
                }
            }

            [data-test-selector="widget_RecentOrders"] ,
            [data-test-selector="cardListRecentWishLists"] {
                > div{
                    width: 100% !important;
                    margin: -15px 0;
                    > div[class*="GridItem"] > div > div {
                        width: calc(100%) !important;
                        margin: -15px 0;
                    }
                }
                .card_container__wrapper {
                    margin: 0;
                    width: 100%;
                    > div > div{
                        padding-left: 0;
                        padding-right: 0;
                    }
                }
                > div > div{
                    padding-left: 0;
                    padding-right: 0;
                }
            }
            
            [data-test-selector="cardListRecentWishLists"] > div,
            [data-test-selector="widget_RecentOrders"] > div {
                width: calc(100% - 30px) !important;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            [data-test-selector="myAccount"] {
                            [data-test-selector="wishListCard"] {
                                    > div {
                                        > div {
                                            &:first-child {
                                                flex-basis: 75%;
                                                max-width: 75%;
                                            }
                                            &:last-child {
                                                flex-basis: 25%;
                                                max-width: 25%;
                                            }
                                        }
                                    }
                                }
                            }
                        `,
                        null,
                    ],
                    "minMax",
                );
            }}
            ul[role="listbox"]{
                &[class*="PopoverStyle-"] {
                    width: 100% !important;
                }
            }
        `,
    },
});
